import React, {useRef, useState, useEffect, useContext} from 'react'
import icon from './icons/icon.svg'
import {
  Container,
  ContainerContent,
  DriversContent,
  DriversImg,
  DriversTitle,
} from './styles'
import { requestTranslation } from "@futures-platform/i18n";
import { votingApi } from '../../helpers/fetcher';
import {DataContext} from '../../store/GlobalState'
import { ACTIONS } from '../../store/Actions';
const RelatedScenarios = ({
  gid,
  // scenarioSetId,
  relatedScenarios,
  isTitleNotShown,
  isTranslated,
  langForTransState
}) => {
  const titleRef = useRef()
    const nameRef = useRef()
    const titleRef2 = useRef()
    const nameRef2 = useRef()
    const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateStore, getTheWholeCardHtmlElms}, dispatch } = useContext(DataContext)

    const [translations, settranslations] = useState(null)
    const [originalTitle, setoriginalTitle] = useState(null)
    const [originalText, setoriginalText] = useState(null)

  
    useEffect(() => {
      const fetcher = async () => {
        const [res1] = await Promise.all ([
            votingApi.translation("en", langForTransState, originalTitle),
            // votingApi.translation("en", langForTransState, originalText)
        ])
        const res2 = await Promise.all (
          !!originalText?.length && originalText?.map( child => {

            if(!!child) {
              return votingApi.translation("en", langForTransState, child?.innerHTML)
            }
            
          })
        )
        
        settranslations(() => {
          return {
            res1, res2
          }
        })
      };
      !!isTranslated && !! originalTitle && !!originalText && fetcher();
      
    }, [isTranslated, originalText, originalTitle, langForTransState])
  
    useEffect(() => {
      if (!!relatedScenarios && !!relatedScenarios?.length) {
        if (true) {
          let namesOfPhencollection = []
          if(!!titleRef.current?.innerHTML && !titleRef2.current) {
            titleRef2.current = titleRef.current?.innerHTML
          }
          !!titleRef2.current && !originalTitle && setoriginalTitle(() => titleRef2.current)
          const phenList = Array.from(nameRef.current?.children ?? []) 
          !!phenList?.length && phenList?.map( child => {

            if(!!child) {
              const tempElm = child?.querySelector('h4') 

              namesOfPhencollection = [...namesOfPhencollection, tempElm]
            }
            
          })

          if (!!nameRef.current && !nameRef2.current && !!namesOfPhencollection?.length) {
            nameRef2.current = namesOfPhencollection
          }
          namesOfPhencollection = namesOfPhencollection?.filter((name) =>  !!name)
          !!nameRef2.current && !originalText && setoriginalText(() => namesOfPhencollection)
          // dispatch({
          //   type: ACTIONS.GETWHOLEHTMLCARD9,
          //   payload: true
          // })

        }
      }
    }, [dispatch, isTranslated, originalText, originalTitle, relatedScenarios])

  return (
    <>
    {
      !!relatedScenarios && !!relatedScenarios?.length ? <Container ref={nameRef}>
      {!!relatedScenarios && !!relatedScenarios?.length && (
        <>
          {!isTitleNotShown && !isTranslated && <DriversTitle ref={titleRef}>{requestTranslation("relatedScenario")}</DriversTitle>}
          {!isTitleNotShown && !!isTranslated && <DriversTitle ref={titleRef} dangerouslySetInnerHTML={{__html: translations?.res1?.data}}></DriversTitle>}
          {relatedScenarios?.map((scenario, i) => {
            return (
              <ContainerContent key={i}>
                <button
                  style={{
                    border: 'none',
                    background: 'transparent',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                  className="scenario-link right"
                  data-href={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                  data-uri={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="8" fill="white"/>
                    <path d="M11.7647 7.71764L16 7.71764C15.8407 3.52305 12.4769 0.159288 8.28236 0V4.23529C8.38962 6.11231 9.88769 7.61038 11.7647 7.71764Z" fill="#689AB9"/>
                    <path d="M8.28236 11.7647V16C12.4769 15.8407 15.8407 12.4769 16 8.28236H11.7647C9.88769 8.38962 8.38962 9.88769 8.28236 11.7647Z" fill="#689AB9"/>
                    <path d="M4.23529 8.28236H0C0.159288 12.4769 3.52305 15.8407 7.71764 16V11.7647C7.61038 9.88769 6.11231 8.38962 4.23529 8.28236Z" fill="#689AB9"/>
                    <path d="M7.71764 4.23529V0C3.52305 0.159288 0.159288 3.52305 0 7.71764H4.23529C6.11231 7.61038 7.61038 6.11231 7.71764 4.23529Z" fill="#689AB9"/>
                  </svg>
                </button>
                {/* <DriversImg
                  src={icon}
                  className="scenario-link right"
                  data-href={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                  data-uri={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                /> */}
                {
                  !isTranslated && (
                    <DriversContent
                  className="scenario-link right"
                  data-href={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                  data-uri={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}>
                  {scenario?.content?.title}
                </DriversContent>
                  )
                }
                {
                  !!isTranslated && (
                    <DriversContent
                  className="scenario-link right"
                  data-href={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}
                  data-uri={`fp-scenario-card/${!!scenario?.groups?.length ? scenario?.groups[0]: gid}/${scenario?.content?.scenarioSetId}/${scenario?.id}`}>
                  {translations?.res2[i]?.data}
                </DriversContent>
                  )
                }
              </ContainerContent>
            )
          })}
        </>
      )}
    </Container> : null
    }
    </>
  )
}

export default RelatedScenarios
